import React, { useState, useRef } from "react";
import "./VerificationInput.scss";

interface VerificationInputProps {
  length?: number;
  onComplete: (code: string) => void;
}

const VerificationInput: React.FC<VerificationInputProps> = ({
  length = 6,
  onComplete,
}) => {
  const [values, setValues] = useState<string[]>(Array(length).fill(""));
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const value = e.target.value;

    if (value.match(/^[0-9]$/)) {
      const newValues = [...values];
      newValues[index] = value;
      setValues(newValues);

      if (index < length - 1) {
        inputRefs.current[index + 1]?.focus();
      }

      if (newValues.join("").length === length) {
        onComplete(newValues.join(""));
      }
    }
  };

  const handleBackspace = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number
  ) => {
    if (e.key === "Backspace") {
      if (!values[index] && index > 0) {
        inputRefs.current[index - 1]?.focus();
      }
      const newValues = [...values];
      newValues[index] = "";
      setValues(newValues);
    }
  };

  return (
    <div className='verification-input-cont'>
      {values.map((value, index) => (
        <div className='verification-input' key={index}>
          <input
            className='input-veri-cont'
            type='text'
            maxLength={1}
            value={value}
            onChange={(e) => handleChange(e, index)}
            onKeyDown={(e) => handleBackspace(e, index)}
            ref={(ref) => (inputRefs.current[index] = ref)}
          />
        </div>
      ))}
    </div>
  );
};

export default VerificationInput;
